import _find from 'lodash/find';

function Ctrl($rootScope, $scope, jsSdkPaymentProfile, jsSdkUser, modalService) {
  $rootScope.$on('payment-profile-updated', () => {
    $scope.getDefaultPaymentProfile();
  });

  $scope.getDefaultPaymentProfile = function() {
    $scope.loading = true;

    const userId = jsSdkUser.getCurrentUser().id;

    jsSdkPaymentProfile.listByUserId(userId)
      .then(resp => {
        if (!resp.length) {
          $scope.loading = false;
        }

        $scope.loading = false;

        $scope.card = _find(resp, {
          default: true
        }) || resp.pop();
      }, () => {
        $scope.loading = false;
      }, () => {
        $scope.loading = false;
      });
  };

  $scope.editCreditCard = function() {
    modalService.editCreditCard();
  };

  $scope.getDefaultPaymentProfile();
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  'jsSdk.paymentProfile',
  'jsSdk.user',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/creditCardPreview/controller.js